var stickers = ['acetate', 'bio', 'bio_acetate', 'recycled'];

function preview_product(e) {
	var li = e.currentTarget;

	var collection_div = select_parent(li, '.collection');
	var product_div = collection_div.querySelector('.product');

	product_div.querySelector('h2').textContent = li.dataset.title;
	product_div.querySelector('img').src = li.dataset.img;
	product_div.querySelector('.hover').src = li.dataset.hover_img;
	product_div.querySelector('a').href = li.querySelector('a').href;

	product_div.querySelector('.sold_out').hidden = li.dataset.available == 1;

	var price = product_div.querySelector('.h > span:not(.original_price)');
	var original_price = product_div.querySelector('.original_price');
	var discount_tag = product_div.querySelector('.discount_tag');

	var new_price = Number(li.dataset.price) / 100;
	price.textContent = price.textContent.replace( /\d[0-9,.]*/, new_price );

	if (li.dataset.original_price) {
		var new_original_price = Number(li.dataset.original_price) / 100;
		var discount_rate = (new_price / new_original_price - 1) * -100;

		original_price.textContent = original_price.textContent.replace( /\d[0-9,.]*/, new_original_price );
		discount_tag.textContent = '-' + Math.round(discount_rate) + '%';

		price.classList.add('discounted_price');
		original_price.hidden = false;
		discount_tag.hidden = false;
	}

	else {
		product_div.querySelectorAll('.discounted_price').forEach( function(x) {
			x.classList.remove('discounted_price');
		} );

		original_price.hidden = true;
		discount_tag.hidden = true;
	}

	stickers.forEach( function(x) {
		product_div.querySelector('.stickers .' + x + '_tag').hidden = li.dataset[x] != 1;
	} );

	collection_div.querySelectorAll('.variant_selector li').forEach( function(x) {
		x.classList.remove('selected');
	} );

	li.classList.add('selected');
}


// ...

document.querySelectorAll('.variant_selector li').forEach( function(x) {
	x.addEventListener('mouseover', preview_product);
	x.addEventListener('click', preview_product);
} );

document.querySelectorAll('.variant_selector a').forEach( function(x) {
	x.addEventListener( 'click', function(e) {
		e.preventDefault();
	} );
} );